import { render, staticRenderFns } from "./statusRules.vue?vue&type=template&id=49a85162&scoped=true"
import script from "./statusRules.vue?vue&type=script&lang=js"
export * from "./statusRules.vue?vue&type=script&lang=js"
import style0 from "./statusRules.vue?vue&type=style&index=0&id=49a85162&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a85162",
  null
  
)

export default component.exports